import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class AuthSessionRecoveryStore {
  private readonly reauthRequiredSignal = signal(false);
  private readonly returnUrlSignal = signal('/');

  readonly isReauthRequired = this.reauthRequiredSignal.asReadonly();
  readonly returnUrl = this.returnUrlSignal.asReadonly();

  requestReauth(returnUrl: string) {
    this.returnUrlSignal.set(returnUrl || '/');
    this.reauthRequiredSignal.set(true);
  }

  clear() {
    this.reauthRequiredSignal.set(false);
  }
}
